import { Promise } from "rsvp";
import { ajax } from "discourse/lib/ajax";
import { getOwner } from "discourse/lib/get-owner";

function confirmDialog(message) {
  const dialog = getOwner(this).lookup("service:dialog");
  return new Promise((resolve, reject) => {
    dialog.confirm({
      message,
      didConfirm: () => {
        resolve();
      },
      didCancel: () => {
        reject();
      },
    });
  });
}

function sendRequest(subscriptionDetails) {
  return ajax("/admin/downgrade.json", {
    type: "POST",
    data: {
      plan_id: subscriptionDetails.plan_id,
      add_on_ids: subscriptionDetails.add_on_ids,
      coupon_id: subscriptionDetails.coupon_id,
      qty: subscriptionDetails.qty,
    },
  });
}

export async function downgrade(subscriptionDetails) {
  const dialog = getOwner(this).lookup("service:dialog");

  try {
    const data = await sendRequest(subscriptionDetails);

    if (data.success) {
      return dialog.alert(
        data.message ||
          "Your plan has been successfully changed. Your site will reflect the changes soon."
      );
    } else {
      return dialog.alert(
        `Your plan change could not be completed. ${data.message}`
      );
    }
  } catch {
    return dialog.alert(
      "There was an error submitting your request. Please send an email to team@discourse.org so we can look into it."
    );
  }
}

export async function downgradeWithConfirmation(subscriptionDetails) {
  const confirmMessage = `Are you sure you want to change plans?`;

  await confirmDialog(confirmMessage);
  return downgrade(subscriptionDetails);
}
